export const QuestionType = Object.freeze({
  COMMENT: 'comment',
  SLIDER: 'slider',
  MULTIPLE_CHOICE: 'multipleChoice',
  RATING_SCALE_MINMAX: 'rating_scale_minmax',
  MULTI_SELECT_CHOICE: 'multi_select_choice',
  STAR: 'star',
  FILE_UPLOAD: 'file_upload',
})


export const isUnratedQuestionType = (type) =>
  type === QuestionType.COMMENT || type === QuestionType.FILE_UPLOAD



//////////////////
// WEBPACK FOOTER
// ../packages/question-types/index.js
// module id = 187
// module chunks = 13